import React, { Component } from 'react';
import EventShort from './EventShort';
import appconfig from '../utils/appconfig';
import srvEvents from '../services/srv-events';

import "../css/lastevents.css"

class LastEvents extends Component {

    constructor(props) {
        super(props);
        this.state = { concerts: [] };
        this.getLastEvents = this.getLastEvents.bind(this);
    }

    componentDidMount() {
        srvEvents.getNextEvent().then(data => {
            this.setState({ concerts: data });
        }).catch(this.handleError);
    }

    getLastEvents() {
        let {concerts} = this.state;
        let nextConcerts = [];
        let now = new Date();
        for (var i = 0; i < concerts.length; i++) {
            if (new Date(concerts[i].enddatetime) > now) {
                nextConcerts.push(concerts[i]);
                if (nextConcerts.length === appconfig.lastEventNumber)
                    break;
            }
        }
        return nextConcerts;
    }

    render() {
        const nextConcerts = this.getLastEvents();
        return (
            <div>
                <div className="container rounded z-depth-1 eventscontainer">
                    {
                        nextConcerts.map((concert) => <EventShort key={concert.id} event={concert}></EventShort>
                        )
                    }
                </div>
            </div>
        );
    }
}

export default LastEvents;


// WEBPACK FOOTER //
// ./src/components/LastEvents.js